import React from "react"
import { useTranslation } from "react-i18next"
import classes from "./NextOrganization.module.scss"

const NextOrganization: React.FC = () => {
  const { t } = useTranslation("home")
  return (
    <div className={classes.NextOrganizationWrapper}>
      <h2 className={classes.Heading}>{t("Next Event")}</h2>
      <p className={classes.Date}>
        {t("January 5th (Fri.) - 7th (Sun.), 2024")}
      </p>
      <p className={classes.Location}>
        {t("Loisir Hotel Toyohashi (Toyohashi, Aichi)")}
      </p>
    </div>
  )
}

export default NextOrganization
